import {
  configuredReviewerPubs,
  sealApplicantRecord,
  type SealedApplication,
} from './applicantCrypto';
import {
  requireApplicationIdentity,
  type ApplicationIdentity,
} from './applicationIdentity';

export interface SealedInsert {
  wallet_address: string;
  did_id: number;
  role: string;
  content_hash: string;
  encrypted_payload: SealedApplication;
}

export async function sealApplicationForInsert(opts: {
  role: string;
  plaintext: Record<string, unknown>;
  files?: Array<{ name: string; type: string; bytes: Uint8Array }>;
  connectedAddress?: string | null;
  reviewerPubs?: Array<{ kid: string; publicHex: string }>;
  identity?: ApplicationIdentity;
}): Promise<SealedInsert> {
  const identity =
    opts.identity ?? (await requireApplicationIdentity(opts.connectedAddress));
  const reviewerPubs = opts.reviewerPubs ?? configuredReviewerPubs();
  const sealed = await sealApplicantRecord({
    didId: identity.didId,
    role: opts.role,
    plaintext: opts.plaintext,
    files: opts.files,
    reviewerPubs,
  });
  return {
    wallet_address: identity.walletAddress,
    did_id: identity.didId,
    role: opts.role,
    content_hash: sealed.plaintextHash,
    encrypted_payload: sealed,
  };
}

export async function fileToBytes(file: File): Promise<Uint8Array> {
  const buf = await file.arrayBuffer();
  return new Uint8Array(buf);
}
